import {useRef, useState} from 'react';

import * as css from '#component/partial/LifestyleTrendChart/LifestyleTrendChart.css';
import {useOnceEffect} from '#hook';

import {TickProps} from './Tick.types';

/**
 * `Tick` is a component that may be passed as the `tickComponent` prop value
 * for a visx "Axis" component. It is used to render a themed tick for charts.
 */
export const Tick = ({formattedValue, isLast, x = 0, y = 0}: TickProps) => {
  const [textHeight, setTextHeight] = useState(0);
  const [textWidth, setTextWidth] = useState(0);
  const textRef = useRef<SVGTextElement>(null);

  // Calculate size of background in an effect in order to force a re-render.
  useOnceEffect(() => {
    const {width, height} = textRef.current?.getBBox() || {};

    if (
      typeof height === 'number' &&
      typeof width === 'number' &&
      (textHeight !== height || textHeight !== width)
    ) {
      setTextHeight(height);
      setTextWidth(width);
    }
  });

  return (
    <>
      {isLast && (
        <rect
          className={css.currTickBg}
          height={textHeight + 8}
          rx={4}
          ry={4}
          // Position `<rect>` behind `<text>`,
          // with offsets to account for padding.
          width={textWidth + 16}
          x={x - textWidth / 2 - 8}
          y={y - textHeight / 2 - 9}
        />
      )}

      <text className={isLast ? css.currTick : undefined} ref={textRef} x={x} y={y}>
        {formattedValue}
      </text>
    </>
  );
};
